import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { tap } from 'rxjs/operators';
import { Api } from 'src/app/shared/constants/api';
import { PermissionKey } from 'src/app/shared/constants/permissionCode';
import { IPermissionWithShow } from 'src/app/shared/interface';
import { DataService } from 'src/app/shared/services/data.service';
import { PermissionService } from 'src/app/shared/services/permissions.service';
import { UtilityService } from 'src/app/shared/services/utility.service';
import * as _ from 'underscore';
import { UnitFormComponent } from '../unit-form/unit-form.component';
import { IUnit, IUnitCriteria } from '../unit.interface';

@Component({
    selector: 'app-unit-view',
    templateUrl: './unit-view.component.html',
    styleUrls: ['./unit-view.component.less'],
    standalone: false
})
export class UnitViewComponent implements OnInit {

  unitForm: FormGroup;
  criteria: IUnitCriteria = {};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  pageSizeOptions: Array<number> = this.utilityService.getPageSizeOptions();
  totalUnitRecords:number;
  unitColumns = ['name' , 'code' , 'action'];
  permissions = [];
	addPermission : boolean = false;
	viewPermission : boolean = false;
  public dataSource = new MatTableDataSource<IUnit>();

  constructor(private service: DataService,
              private formBuiler: FormBuilder, private dialog: MatDialog,
              private utilityService: UtilityService, private permissionService:PermissionService ) { }

  ngOnInit(): void {
    this.checkAllPermission();
    this.initializeForm();
    this.nameValueChangeEvent();
  }

  ngAfterViewInit() 
	{
    this.dataSource.sort=this.sort;
    this.dataSource.paginator=this.paginator;
		this.paginator?.page?.pipe(tap(() => this.getUnits())).subscribe();
		this.getUnits();
	}

  private initializeForm() {
    this.unitForm = this.formBuiler.group({
      id: [null],
      name: [null],
      code: [null]
    });
  }

  nameValueChangeEvent(){
    this.name.valueChanges.subscribe(unitName => {
      this.criteria['name.contains']=unitName;
      this.getUnits();
    })
    this.code.valueChanges.subscribe(unitCode => {
      this.criteria['code.contains']=unitCode;
      this.getUnits();
    })
  }

  private getUnits() {
    this.criteria.page=this.paginator?.pageIndex;
    this.criteria.size=this.paginator?.pageSize;
    if(this.viewPermission){
        this.service.get(Api.UNIT, this.criteria).subscribe(res => {
          this.dataSource = res.contents;
          this.totalUnitRecords = res.totalRecords;
      });
    }
  }

  sortData(event: { active: string; direction: string; }){
    this.criteria.sort = [event.active, event.direction];
    this.getUnits();
	}

  openForm(row?: any): void {
    const dailogRef = this.dialog.open(UnitFormComponent, { data: row });
    dailogRef.afterClosed().subscribe(() => this.getUnits());
}

public checkAllPermission(){
    let permissionCodes=[PermissionKey.UNIT_MODULE_ADD_PERMISSION,PermissionKey.UNIT_MODULE_VIEW_PERMISSION,PermissionKey.UNIT_MODULE_EDIT_PERMISSION ];
    let permissionsWithShowValue:IPermissionWithShow[]=this.permissionService.checkPermissions(permissionCodes,PermissionKey.UNIT_MODULE);
    this.addPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.UNIT_MODULE_ADD_PERMISSION})?.show?true:false;
    this.viewPermission=_.findWhere(permissionsWithShowValue,{permissionCode:PermissionKey.UNIT_MODULE_VIEW_PERMISSION})?.show?true:false;
}

get name(){ return this.unitForm.get('name'); }
get code(){ return this.unitForm.get('code'); }

}
